// registration.component.ts
import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule, FormControl } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatRadioModule } from '@angular/material/radio';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { SharedService } from '../../services/shared-services';
import { map, Observable, startWith } from 'rxjs';
import { VendorService } from '../../services/vendor-service';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
//import { MatDivider } from '@angular/material/divider';

@Component({
  selector: 'app-vendor-registration',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatButtonModule,
    MatRadioModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatCheckboxModule,
    MatChipsModule,
    MatIconModule,
    MatAutocompleteModule
  ],
  templateUrl: './vendor-registration.component.html',
  styleUrls: ['./vendor-registration.component.css']
})
export class VendorRegistrationComponent {
  vendorForm: FormGroup;
  businessTypes = [
    'Manufacturer',
    'Distributor',
    'Retailer',
    'Service Provider',
    'Other'
  ];
  states$!: Observable<any[]>;
  // countries: any[] = [];
  // filteredCountries$!: Observable<any[]>;
  districts: any[] = [];
  titles$!: Observable<any[]>;
  tags$!: Observable<any[]>;
  selectedFiles: any = {};
  suppliedEarlier: boolean = false;
  isLoading = false;
  countryCode:string='SA';
  countryControl = new FormControl<ModelData | string>('');
  countries: ModelData[] = [];
  filteredCountries$!: Observable<ModelData[]>;

  

  constructor(private fb: FormBuilder, private sharedService: SharedService, private router: Router, private vendorService: VendorService, private http: HttpClient, private snackBar: MatSnackBar) {
    this.vendorForm = this.fb.group({
      companyName: ['', Validators.required],
      address1: ['', Validators.required],
      address2: [''],
      buildingNumber: [''],
      additionalNumber: [''],
      stateId: ['', Validators.required],
      countryId: ['', Validators.required],
      districtOrNeighborhood: ['', Validators.required],
      titleId: [''],
      // zipCode: ['', [
      //   Validators.required,
      //   Validators.pattern(/^\d{5}$/)    // exactly 10 digits
      // ]],
      // vatNumber: ['', [
      //   Validators.required,
      //   Validators.pattern(/^3\d{14}$/)   // starts with 3 and total 15 digits
      // ]],
      groupVatNumber: [''],
      // commercialRegNo: ['', [
      //   Validators.required,
      //   Validators.pattern(/^\d{10}$/)    // exactly 10 digits
      // ]],
      commercialRegNo: [''],
      vatNumber: [''],
      zipCode: [''],
      contactPerson: [''],
      city: ['', Validators.required],
      phone: ['', Validators.required],
      contactphone: [''],
      suppliedEarlier: [''],
      otherId: [''],
      businessID: [[]],
      designation: [''],
      suppliedMonthYear: [''],
      mobile: [''],
      email: ['', [Validators.required, Validators.email]],
      contactemail: ['', [Validators.email]],
      // password:['', Validators.required],
      // repassword: ['', Validators.required],
      password: ['', [
        Validators.required,
        Validators.minLength(8),
        Validators.maxLength(20)
        // Validators.pattern(/^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@$!%*?&]).+$/)
      ]],
      confirmpassword: ['', Validators.required]
    }, {
      validators: this.confirmPasswordValidator('password', 'confirmpassword')
    });
  }

  confirmPasswordValidator(passwordControl: string, confirmPasswordControl: string): ValidatorFn {
    return (formGroup: AbstractControl): ValidationErrors | null => {
      const password = formGroup.get(passwordControl);
      const confirmPassword = formGroup.get(confirmPasswordControl);

      if (!password || !confirmPassword) {
        return null;
      }

      if (confirmPassword.errors && !confirmPassword.errors['mismatch']) {
        // if other validators (like required) are present, don’t overwrite them
        return null;
      }

      if (password.value !== confirmPassword.value) {
        confirmPassword.setErrors({ mismatch: true });
        return { mismatch: true };
      } else {
        confirmPassword.setErrors(null);
        return null;
      }
    };
  }


  // confirmPasswordValidator(passwordControl: string, confirmPasswordControl: string): ValidatorFn {
  //   return (formGroup: AbstractControl): ValidationErrors | null => {
  //     const password = formGroup.get(passwordControl)?.value;
  //     const confirmPassword = formGroup.get(confirmPasswordControl)?.value;

  //     if (password && confirmPassword && password !== confirmPassword) {
  //       formGroup.get(confirmPasswordControl)?.setErrors({ mismatch: true });
  //       return { mismatch: true };
  //     } else {
  //       formGroup.get(confirmPasswordControl)?.setErrors(null);
  //       return null;
  //     }
  //   };
  // }

  ngOnInit() {
    this.getCountries();
    this.vendorForm.get('countryId')?.valueChanges.subscribe((countryId: number) => {
      if (countryId) {
        this.getStates(countryId);
        this.vendorForm.get('stateId')?.reset();
      } else {
      }
    });
    this.getTitles();
    this.getTags();
  }

  VATFileName: string = '';
  MOMRAFileName: string = '';
  MSLDFileName: string = '';
  SAGIAFileName: string = '';
  CRFileName: string = '';
  IBANFileName: string = '';
  VATBinaryFile: string | null = null;
  MOMRABinaryFile: string | null = null;
  MSLDBinaryFile: string | null = null;
  SAGIABinaryFile: string | null = null;
  CRBinaryFile: string | null = null;
  IBANBinaryFile: string | null = null;
  onFileChange(event: any, fileType: string) {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];
    if (!file) return;
    switch (fileType) {
      case "VAT": this.VATFileName = file.name; break;
      case "MOMRA": this.MOMRAFileName = file.name; break;
      case "MSLD": this.MSLDFileName = file.name; break;
      case "SAGIA": this.SAGIAFileName = file.name; break;
      case "CR": this.CRFileName = file.name; break;
      case "IBAN": this.IBANFileName = file.name; break;
    }
    this.uploadFileAsBinary(file, fileType);
  }

  uploadFileAsBinary(file: File, fileType: string) {
    const reader = new FileReader();
    reader.onload = () => {
      const dataUrl = reader.result as string;
      const base64 = dataUrl.split(',')[1];
      switch (fileType) {
        case "VAT": this.VATBinaryFile = base64; break;
        case "MOMRA": this.MOMRABinaryFile = base64; break;
        case "MSLD": this.MSLDBinaryFile = base64; break;
        case "SAGIA": this.SAGIABinaryFile = base64; break;
        case "CR": this.CRBinaryFile = base64; break;
        case "IBAN": this.IBANBinaryFile = base64; break;
      }
    };
    reader.readAsDataURL(file);
  }

  private arrayBufferToBase64(buffer: ArrayBuffer): string {
    let binary = '';
    const bytes = new Uint8Array(buffer);
    const chunkSize = 0x8000;
    for (let i = 0; i < bytes.length; i += chunkSize) {
      const chunk = bytes.subarray(i, i + chunkSize);
      binary += String.fromCharCode.apply(null, chunk as any);
    }
    let base64 = btoa(binary);
    base64 = base64.replace(/\s/g, '');
    while (base64.length % 4 !== 0) {
      base64 += '=';
    }
    return base64;
  }
// submitVendorForm(){
//    debugger
//     this.router.navigate(['/vendor-evaluation', 100]);
// return;
// }
  submitVendorForm() { 
      
    if (this.vendorForm.invalid) {
      this.vendorForm.markAllAsTouched();
      return;
    }
    if (this.isLoading) return;
    if ((this.VATFileName.length > 0 && this.CRFileName.length > 0) || this.countryCode!='SA') {
      const payload = {
        jsonrpc: '2.0',
        method: 'call',
        params: {
          CompanyName: this.vendorForm.value.companyName,
          Address: this.vendorForm.value.address1,
          AdditionalAddress: this.vendorForm.value.address2,
          BuildingNumber: this.vendorForm.value.buildingNumber,
          // AdditionalNumber: this.vendorForm.value.additionalNumber,
          StateOrProvince: this.vendorForm.value.stateId,
          DistrictOrNeighborhood: this.vendorForm.value.districtOrNeighborhood,
          CountryID: this.vendorForm.value.countryId,
          SuppliedEarlier: this.vendorForm.value.suppliedEarlier,
          MonthAndYear: this.vendorForm.value.suppliedMonthYear,
          BusinessID: this.vendorForm.value.businessID || [],
          City: this.vendorForm.value.city,
          VATNumber: this.vendorForm.value.vatNumber,
          zip: this.vendorForm.value.zipCode,
          GroupVATNumber: this.vendorForm.value.groupVatNumber,
          OtherID: this.vendorForm.value.otherId,
          ContactPerson: this.vendorForm.value.contactPerson,
          Phone: this.vendorForm.value.phone,
          ContactPhone: this.vendorForm.value.contactphone,
          TitleID: this.vendorForm.value.titleId,
          Designation: this.vendorForm.value.designation,
          MobileNumber: this.vendorForm.value.mobile,
          Email: this.vendorForm.value.email.toLowerCase(),
          ContactEmail: this.vendorForm.value.contactemail.toLowerCase(),
          Password: this.vendorForm.value.password,
          CommercialRegNo: this.vendorForm.value.commercialRegNo,
          CRCertificate: this.CRBinaryFile,
          VATCertificate: this.VATBinaryFile,
          MOMRALicense: this.MOMRABinaryFile,
          MSLDLicense: this.MSLDBinaryFile,
          SAGIALicense: this.SAGIABinaryFile,
          VATCertificate_filename: this.VATBinaryFile && this.VATBinaryFile.length>0 ? this.vendorForm.value.commercialRegNo + '-VAT.' + this.VATFileName.split('.').pop() || '':'',
          MOMRALicense_filename: this.MOMRABinaryFile && this.MOMRABinaryFile.length>0 ? this.vendorForm.value.commercialRegNo + '-MOMRAL.' + this.MOMRAFileName.split('.').pop() || '':'',
          MSLDLicense_filename: this.MSLDBinaryFile && this.MSLDBinaryFile.length>0? this.vendorForm.value.commercialRegNo + '-MSLDL.' + this.MSLDFileName.split('.').pop() || '':'',
          SAGIALicense_filename: this.SAGIABinaryFile && this.SAGIABinaryFile.length>0 ? this.vendorForm.value.commercialRegNo + '-SAGIAL.' + this.SAGIAFileName.split('.').pop() || '':'',
          CR_filename: this.CRBinaryFile && this.CRBinaryFile.length>0 ? this.vendorForm.value.commercialRegNo + '-CR.' + this.CRFileName.split('.').pop() || '':'',
          IBANCertificate:this.IBANBinaryFile,// this.vendorForm.value.commercialRegNo + '-IBAN.' + this.IBANFileName.split('.').pop() || '',
          IBANCertificateFilename:this.IBANBinaryFile && this.IBANBinaryFile.length>0 ? this.vendorForm.value.commercialRegNo + '-IBAN.' + this.IBANFileName.split('.').pop() || '':'',
        }
      };
      this.isLoading = true;
      this.vendorService.signupVendor(payload).subscribe({
        next: (res) => {
          this.isLoading = false;
          if (res && res.result && res.result.code == 200 && res.result.success) {
            // this.router.navigate(['/registration-success', res.result.approval_id, 'vendor']);
             this.router.navigate(['/vendor-evaluation', res.result.approval_id]);
          }
          else {
            this.snackBar.open('Vendor registration failed', 'Close', {
              duration: 3000,
              panelClass: ['error-snackbar']
            });
          }
        },
        error: (err) => {
          this.isLoading = false;
          this.snackBar.open('Vendor registration failed', 'Close', {
            duration: 3000,
            panelClass: ['error-snackbar']
          });
        }
      });
    }
    else {
      this.snackBar.open('Company registration and VAT certificates are mandatory for Saudi Arabia', 'Close', {
        duration: 3000,
        panelClass: ['error-snackbar']
      });
    }
  }

  // getCountries() {
  //   this.countries$ = this.sharedService.getCountries().pipe(
  //     map((res: any) => res.result.data)
  //   );
  // }

  getCountries() {
     this.sharedService.getCountries().subscribe((res: any) => {
       this.countries = res.result.data as ModelData[];
 
       this.filteredCountries$ = this.countryControl.valueChanges.pipe(
         startWith(''),
         map(value => (typeof value === 'string' ? value : value?.name || '')),
         map(name => this._filterountries(name))
       );
     });
   }
 
   private _filterountries(value: string): ModelData[] {
     const filterValue = value.toLowerCase();
     return this.countries.filter(option =>
       option.name.toLowerCase().includes(filterValue)
     );
   }
 
   onCountrySelected(selected: ModelData) {
     this.vendorForm.patchValue({ countryId: selected.id });
this.countryCode=this.countries.filter(x=> x.id==selected.id)[0].code;
this.updateCountryBasedValidators(this.countryCode);
   }

   private updateCountryBasedValidators(countryCode: string): void {
  const crControl = this.vendorForm.get('commercialRegNo');
  const vatControl = this.vendorForm.get('vatNumber');
  const zipControl = this.vendorForm.get('zipCode');
  const buildingControl = this.vendorForm.get('buildingNumber');

  // Clear existing validators
  crControl?.clearValidators();
  vatControl?.clearValidators();
  zipControl?.clearValidators();
  buildingControl?.clearValidators();

  if (countryCode === 'SA') {
   
    crControl?.setValidators([
      Validators.required,
      Validators.pattern(/^\d{10}$/)
    ]);

    vatControl?.setValidators([
      Validators.required,
      Validators.pattern(/^3\d{14}$/)
    ]);

      zipControl?.setValidators([
      Validators.required,
      Validators.pattern(/^\d{5}$/)
    ]);

      buildingControl?.setValidators([
      Validators.required,      
    ]);


    // zipCode: ['', [
      //   Validators.required,
      //   Validators.pattern(/^\d{5}$/)    // exactly 10 digits
      // ]],
      // vatNumber: ['', [
      //   Validators.required,
      //   Validators.pattern(/^3\d{14}$/)   // starts with 3 and total 15 digits
      // ]],
     // groupVatNumber: [''],
      // commercialRegNo: ['', [
      //   Validators.required,
      //   Validators.pattern(/^\d{10}$/)    // exactly 10 digits
      // ]],
  } else {
   
  }

  crControl?.updateValueAndValidity();
  vatControl?.updateValueAndValidity();
  zipControl?.updateValueAndValidity();
  buildingControl?.updateValueAndValidity();
}

 
   displayCountryName(country: any): string {
     return country && country.name ? country.name : '';
   }
 

  getStates(countryId: number) {
    this.states$ = this.sharedService.getStates(countryId).pipe(
      map((res: any) => res.result.data)
    );
  }

  getTitles() {
    this.titles$ = this.sharedService.getTitles().pipe(
      map((res: any) => res.result.data)
    );
  }

  getTags() {
    this.tags$ = this.sharedService.getTags().pipe(
      map((res: any) => res.result.data)
    );
  }
}

interface ModelData {
  id: number;
  name: string;
  code:string;
}

